import React, { useState } from "react";
import "./css/OurWork.css";

// Placeholder images - Replace with your project screenshots
import imgProject1 from "./images/mainservices/industry.webp";   
import imgProject2 from "./images/mainservices/fda.webp";
import imgProject3 from "./images/mainservices/customs.webp";
import imgProject4 from "./images/mainservices/agri.webp";
import imgProject5 from "./images/mainservices/nama.webp";
import imgProject6 from "./images/mainservices/certs.webp";

const OurWork = () => {
  const [filter, setFilter] = useState("all");

  // Data based strictly on your provided services content
  const projects = [
    {
      id: 1,
      title: "إصدار رخصة صناعية لمصنع أغذية",
      category: "industry",
      catName: "وزارة الصناعة",
      image: imgProject1,
      link: "https://wa.me/+966573394229",
    },
    {
      id: 2,
      title: "تسجيل منتجات تجميل ومستحضرات",
      category: "fda",
      catName: "هيئة الغذاء والدواء",
      image: imgProject2,
      link: "https://wa.me/+966573394229",
    },
    {
      id: 3,
      title: "تخليص شحنات طبية عبر المنافذ",
      category: "customs",
      catName: "التخليص الجمركي",
      image: imgProject3,
      link: "https://wa.me/+966573394229",
    },
    {
      id: 4,
      title: "ترخيص مشروع استزراع سمكي",
      category: "agri",
      catName: "وزارة البيئة والزراعة",
      image: imgProject4,
      link: "https://wa.me/+966573394229",
    },
    {
      id: 5,
      title: "تسجيل في منصة نَمَا وبرامج الدعم",
      category: "nama",
      catName: "منصة نَمَا",
      image: imgProject5,
      link: "https://wa.me/+966573394229",
    },
    {
      id: 6,
      title: "إصدار شهادات سابر (SABER)",
      category: "certs",
      catName: "إصدار الشهادات",
      image: imgProject6,
      link: "https://wa.me/+966573394229",
    },
  ];

  // Filter Logic
  const filteredProjects =
    filter === "all"
      ? projects
      : projects.filter((project) => project.category === filter);

  return (
    <section className="our-work-section">
      <div className="container">
        
        {/* Header */}
        <div className="section-header">
          <h6>أعمالنا ومشاريعنا</h6>
          <h2>قصص نجاح نعتز بها في نبض كير</h2>
        </div>

        {/* Filter Tabs */}
        <div className="work-filters">
          <button
            className={`filter-btn ${filter === "all" ? "active" : ""}`}
            onClick={() => setFilter("all")}
          >
            الكل
          </button>
          <button
            className={`filter-btn ${filter === "fda" ? "active" : ""}`}
            onClick={() => setFilter("fda")}
          >
            الغذاء والدواء
          </button>
          <button
            className={`filter-btn ${filter === "industry" ? "active" : ""}`}
            onClick={() => setFilter("industry")}
          >
            الصناعة
          </button>
          <button
            className={`filter-btn ${filter === "customs" ? "active" : ""}`}
            onClick={() => setFilter("customs")}
          >
            الجمارك
          </button>
        </div>

        {/* Projects Grid */}
        <div className="row">
          {filteredProjects.map((project) => (
            <div key={project.id} className="col-lg-4 col-md-6 col-sm-12 animate-fade">
              <div className="project-card">
                <img src={project.image} alt={project.title} />
                
                <div className="project-overlay">
                  <span className="project-tag">{project.catName}</span>
                  <h3 className="project-title">{project.title}</h3>
                  <p className="project-category">تم الإنجاز بنجاح</p>
                  
                  {/* Link Icon (Optional: Link to detailed case study) */}
                  <div className="project-link-btn">
                    <a href={project.link} target="_blank" rel="noopener noreferrer">
                    <i class="lab la-whatsapp"></i>
                    </a>
                  </div>
                </div>

              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default OurWork;